/* eslint-disable no-underscore-dangle,class-methods-use-this,react/prop-types */
import React, { Component } from 'react';
import connectToStores from 'common-ui/src/alt/connectToStores';
import StepUpAuthenticationActions from '../actions/StepUpAuthenticationActions';
import StepUpAuthenticationStore from '../stores/StepUpAuthenticationStore';
import SVG from 'common-ui/src/components/images/SVG';

class TokenInput extends Component {
    constructor(props) {
        super(props);

        this._renderTokenInput = this._renderTokenInput.bind(this);
        this._validate = this._validate.bind(this);
        this._onInputKeyDown = this._onInputKeyDown.bind(this);
    }

    static getStores() {
        return [StepUpAuthenticationStore];
    }

    static getPropsFromStores() {
        return StepUpAuthenticationStore.getState();
    }

    render() {
        return <div>{this._renderTokenInput()}</div>;
    }

    _renderTokenInput() {
        return (
            <div className="row">
                <label className="step-up-token-label" htmlFor="token">
                    <img
                        alt=""
                        aria-hidden="true"
                        className="step-up-token-icon"
                        src={`${process.env.REACT_APP_CONTEXT}static/images/icon_vip.png`}
                    />
                    {this.props.securityOptionToken.title}
                </label>
                {this.props.submittingToken ? (
                    <SVG name="SmallLoader" size="sm" />
                ) : null}
                <div className={this.props.validToken ? '' : 'has-error'}>
                    <span className="row col-sm-6 col-xs-12">
                        <input
                            type="text"
                            id="token"
                            name="token"
                            className="form-control"
                            maxLength={
                                this.props.securityOptionToken.maxLengthOTP
                            }
                            value={this.props.token}
                            onChange={this._validate}
                            aria-describedby={
                                this.props.securityOptionToken.title
                            }
                            onBlur={this._validate}
                            onKeyDown={this._onInputKeyDown}
                            placeholder={
                                this.props.securityOptionToken.placeholder
                            }
                            readOnly={false}
                            autoComplete="off"
                            autoCorrect="off"
                            autoCapitalize="off"
                            spellCheck="false"
                        />

                        <div
                            role="alert"
                            aria-live="assertive"
                            aria-atomic="true"
                        >
                            <p className="help-block">
                                <span
                                    id="accessibleAlertMessageToken"
                                    className="sr-only"
                                    role="alert"
                                    tabIndex="-1"
                                >
                                    {!this.props.validToken
                                        ? this.props.securityOptionToken.error
                                        : null}
                                </span>
                                <span
                                    className={
                                        this.props.validToken
                                            ? 'hide'
                                            : 'di-icon-danger'
                                    }
                                    aria-hidden="true"
                                />
                                <span
                                    className={
                                        this.props.validToken
                                            ? 'hide'
                                            : 'show-inline'
                                    }
                                >
                                    {' '}
                                    {this.props.securityOptionToken.error}
                                </span>
                            </p>
                        </div>
                    </span>

                    <span
                        id="tokenButton"
                        className="row col-sm-6 col-xs-12 button-container"
                    >
                        <button
                            type="button"
                            id="tokenSubmit"
                            className="btn btn-primary step-up-button"
                            disabled={
                                this.props.submittingAuthenticator ||
                                this.props.submittingEmail ||
                                this.props.submittingPhone ||
                                this.props.submittingToken
                            }
                            onClick={StepUpAuthenticationActions.submitToken}
                        >
                            {this.props.securityOptionToken.submitBtn}
                        </button>
                    </span>
                </div>
            </div>
        );
    }

    _validate(evt) {
        let token = evt.target.value;

        if (token) {
            token = token.replace(/[^0-9]/g, '');
        }
        StepUpAuthenticationActions.setToken(token);
        const valid =
            token.length <= this.props.securityOptionToken.maxLengthOTP;
        StepUpAuthenticationActions.setValidToken(valid);
    }

    _onInputKeyDown(event) {
        if (event.keyCode === 13) {
            event.preventDefault();
            StepUpAuthenticationActions.submitToken();
        }
    }
}

export default connectToStores(TokenInput);
